import { createContext, ReactNode, useContext, useRef } from 'react';

import { Box, BoxProps } from '@joinrepublic/dls-ui-kit';
import { useInView } from 'framer-motion';

interface MotionBoxGroupProps extends BoxProps {
  children: ReactNode;
  viewportMargin?: string;
  once?: boolean;
}

interface MotionBoxGroupContextValue {
  isGroupInView: boolean;
}

const MotionBoxGroupContext = createContext<MotionBoxGroupContextValue>({
  isGroupInView: false,
});

export const useMotionBoxGroup = () => useContext(MotionBoxGroupContext);

export function MotionBoxGroup({
  children,
  viewportMargin = '0px',
  once = true,
  ...props
}: MotionBoxGroupProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: once,
    margin: viewportMargin,
  });

  return (
    <MotionBoxGroupContext.Provider value={{ isGroupInView: isInView }}>
      <Box ref={ref} {...props}>
        {children}
      </Box>
    </MotionBoxGroupContext.Provider>
  );
}
